////
/// ============================================================================
/// COMPONENT / Scroll
/// ============================================================================
///
/// @group components
////

import LocomotiveScroll from "locomotive-scroll";

export default () => {
    const content = document.querySelector('[data-scroll-container]');

    if (!content) {
        return;
    }

    const scroll = new LocomotiveScroll({
        el: content,
        inertia: 0.6,
        smooth: true,
        smoothMobile: false,
    });

    // aggiorna lo scroll quando cambio le tab
    document.querySelectorAll('.c-tabs_link, .gform_next_button').forEach((element) => {
        element.addEventListener('click', () => {
            scroll.update();
        });
    });

    // aggiorna lo scroll quando invio una form e wpforms segnala errori
    const observer = new MutationObserver(() => {
        scroll.update();
    });

    document.querySelectorAll('.gravity-theme').forEach((element) => {
        observer.observe(element, {
            childList: true,
            subtree: true
        });
    });

    // document.querySelectorAll('.wpforms-page').forEach((element) => {
    //     observer.observe(element, {
    //         attributeFilter: ['style'],
    //         childList: true,
    //         subtree: true
    //     });
    // });

    // aggiorna lo scroll al caricamento di Privacy & Cookie Policy
    if (document.body.classList.contains('privacy-policy') || document.body.classList.contains('cookie-policy')) {
        let timer = setInterval(() => {
            let element = document.querySelector('#iub-pp-container');

            if (!element) {
                return;
            }

            scroll.update();

            clearTimeout(timer);
        }, 500);
    }

    // aggiorna lo scroll al caricamento delle immagini lazyload
    document.querySelectorAll('img[loading="lazy"]').forEach((element) => {
        element.addEventListener('load', () => {
            scroll.update();
        })
    });
}
